// Single source of truth for near-me keyword slugs.
// Used by app/routes.js (route regex) and server/routes/sitemap/index.js (sitemap).
// Adding or removing a slug here updates both automatically.
module.exports = [
	'rv-storage',
	'car-storage',
	'climate-controlled-storage',
	'boat-storage',
	'portable-storage',
	'motorcycle-storage',
	'business-storage',
	'wine-storage',
	'atv-storage',
	'bicycle-storage',
	'dirt-bike-storage',
	'golf-cart-storage',
	'college-storage',
	'truck-storage',
	'jet-ski-storage',
	'kayak-storage',
	'military-storage',
	'drive-up-storage',
	'24-hour-storage',
	'vehicle-storage',
	'mini-storage',
	'5x5-storage',
	'5x10-storage',
	'5x15-storage',
	'10x10-storage',
	'10x15-storage',
	'10x20-storage',
	'10x25-storage',
	'10x30-storage',
	'locker-storage',
	'storage-with-electricity',
	'storage-deals',
	'storage-with-free-truck-rental',
];
